import React from 'react';
import Select from 'react-select';


export const AppSelect = ({ placeholder = 'Select', options, onChange, className, value, color, isMulti = false }) =>  {

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color : state.isFocused ? '#F4F5F8' : 'initial'
        }),
        control: (provided, state) => ({
            ...provided,
            height: '100%',
            borderColor: `${color} !important`,
            backgroundColor: state.isFocused ? '#FFFFFF' : '#F4F5F8',
            color: color,
            boxShadow: 'none'
        })
    }

    const selectedValue = () => {
        if (value === null) {
            return null
        }

        if (typeof value === 'object') {
            return value
        }

        return options.find(el => el.value === value);
    }

    return (
        <Select
            styles={customStyles}
            className={'app-default-select ' + className || ''}
            value={selectedValue()}
            placeholder={placeholder}
            onChange={onChange}
            options={options}
            isMulti={isMulti}
        />
   )
};
